import { PredefinedConfigurationData } from '../../../data/model';
import Selector from '../../../shared/Selector';

export default class PredefinedConfigurationsState extends Selector<PredefinedConfigurationData> {
  constructor(configurations: Array<PredefinedConfigurationData>) {
    super(configurations);
  }
}
